
import React, { useEffect } from "react"
import { connect } from 'react-redux'
import { toggleNav } from '../../state/actions'
import style from './style.module.scss';
import PropTypes from 'prop-types';

const Hamburger = props => {
    let { dispatch, navOpen } = props
    const toggle = () => {
        dispatch(toggleNav(!navOpen))
    }

    /**
     * This function is like a lifecycle method (Example: ComponentDidMount, 
     * ComponentDidUpdate, etc.) We can see here that when we click the hamburger, we change the 
     * navOpen prop, which comes from the redux state
     */
    useEffect(() => {
        console.log("navOpen updated: ", navOpen)
    })
    // ${props.navOpen ? style.open : style.open}`
    console.log("style ", style)
    return (
        <span className={style.container}>
            <div className={`${style.navIcon4} ${navOpen ? style.open : ''}`} onClick={toggle}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </span>
    );
};

Hamburger.propTypes = {
    dispatch: PropTypes.func,
    navOpen: PropTypes.bool
};

export default connect((state, props) => {
    return {
        navOpen: state.navOpen
    }
})(Hamburger);

